//

const setPageStart = () => {
  //

  const setPageInit = () => {
    //

    document.querySelector('.mu_header').classList.add('fadeIn');
    document.querySelector('#MainContent').classList.add('fadeIn');
    document.querySelector('#footer').classList.add('fadeIn');

    //
  };
  setPageInit();

  //

  setCommon();

  //
};
setTimeout(() => {
  setPageStart();
}, 1);

//

const setCommon = () => {
  //

  const setPagetop = () => {
    //

    let pagetopBtn = document.querySelector('.pagetop');
    let fvElem = document.querySelector('.fv');
    let scrollValue = 0;

    pagetopBtn.addEventListener('click', function () {
      if (fvElem) {
        scrollValue = document.querySelector('#items').offsetTop;
      }
      window.scrollTo({
        top: scrollValue,
        behavior: 'smooth',
      });
    });

    //
  };
  setPagetop();

  //

  const setNav = () => {
    //

    document.querySelector('.mu_header .nav_switch').addEventListener('click', () => {
      document.querySelector('.mu_header').classList.toggle('open');
    });

    document.querySelector('header .close_bg').addEventListener('click', () => {
      document.querySelector('header').classList.remove('open');
    });

    //
  };
  setNav();

  //

  //*****
  //
  const setFadeInEffect = () => {
    //

    //*****  basic
    //
    const fadeOs = document.querySelectorAll('.fadeO');
    const fadeBs = document.querySelectorAll('.fadeB');
    const fadeB10s = document.querySelectorAll('.fadeB10');
    const fadeTs = document.querySelectorAll('.fadeT');
    const fadeRs = document.querySelectorAll('.fadeR');
    const fadeR10s = document.querySelectorAll('.fadeR10');
    const fadeLs = document.querySelectorAll('.fadeL');
    const fadeLines = document.querySelectorAll('.fadeLine');
    const fadeLineLs = document.querySelectorAll('.fadeLineL');
    const fadeLineRs = document.querySelectorAll('.fadeLineR');
    const fadePhotos = document.querySelectorAll('.fadePhoto');
    const fadePhotoBs = document.querySelectorAll('.fadePhotoB');
    const fadePhotoB30s = document.querySelectorAll('.fadePhotoB30');
    const fadeBoxLs = document.querySelectorAll('.fadeBoxL');
    const fadeBoxRs = document.querySelectorAll('.fadeBoxR');
    const fadeElems = document.querySelectorAll('.fadeElem');
    //
    const options = {
      root: null,
      rootMargin: '-10% 0px',
      threshold: 0,
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    //
    function observerInit() {
      fadeOs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeBs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeB10s.forEach((elem) => {
        observer.observe(elem);
      });
      fadeTs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeRs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeR10s.forEach((elem) => {
        observer.observe(elem);
      });
      fadeLs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeLines.forEach((elem) => {
        observer.observe(elem);
      });
      fadeLineLs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeLineRs.forEach((elem) => {
        observer.observe(elem);
      });
      fadePhotos.forEach((elem) => {
        observer.observe(elem);
      });
      fadePhotoBs.forEach((elem) => {
        observer.observe(elem);
      });
      fadePhotoB30s.forEach((elem) => {
        observer.observe(elem);
      });
      fadeBoxLs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeBoxRs.forEach((elem) => {
        observer.observe(elem);
      });
      fadeElems.forEach((elem) => {
        observer.observe(elem);
      });
    }
    observerInit();
    //
    // if ($('.index_content').length) {
    //   setTimeout(() => {
    //     observerInit();
    //   }, 1000);
    // } else {
    //   observerInit();
    // }

    //

    //*****  fv
    //
    const fadeFvOs = document.querySelectorAll('.fadeFvO');
    const fadeFvBs = document.querySelectorAll('.fadeFvB');
    const fadeFvB10s = document.querySelectorAll('.fadeFvB10');
    const fadeFvTs = document.querySelectorAll('.fadeFvT');
    const fadeFvRs = document.querySelectorAll('.fadeFvR');
    const fadeFvR10s = document.querySelectorAll('.fadeFvR10');
    const fadeFvLs = document.querySelectorAll('.fadeFvL');
    const fadeFvLines = document.querySelectorAll('.fadeFvLine');
    const fadeFvLineLs = document.querySelectorAll('.fadeFvLineL');
    const fadeFvLineRs = document.querySelectorAll('.fadeFvLineR');
    const fadeFvPhotos = document.querySelectorAll('.fadeFvPhoto');
    const fadeFvPhotoBs = document.querySelectorAll('.fadeFvPhotoB');
    const fadeFvPhotoB30s = document.querySelectorAll('.fadeFvPhotoB30');
    const fadeFvBoxLs = document.querySelectorAll('.fadeFvBoxL');
    const fadeFvBoxRs = document.querySelectorAll('.fadeFvBoxR');
    const fadeFvElems = document.querySelectorAll('.fadeFvElem');

    //
    const optionsFv = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0,
    };
    const observerFv = new IntersectionObserver(doWhenIntersect, optionsFv);
    //
    function observerFvInit() {
      fadeFvOs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvBs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvB10s.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvTs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvRs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvR10s.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvLs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvLines.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvLineLs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvLineRs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvPhotos.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvPhotoBs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvPhotoB30s.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvBoxLs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvBoxRs.forEach((elem) => {
        observerFv.observe(elem);
      });
      fadeFvElems.forEach((elem) => {
        observerFv.observe(elem);
      });
    }
    observerFvInit();
    //
    // if ($('.index_content').length) {
    //   setTimeout(() => {
    //     observerFvInit();
    //   }, 800);
    // } else {
    //   observerFvInit();
    // }

    //*****  set class
    //
    function doWhenIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }
  };
  setFadeInEffect();

  //
};
